/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, InfoLabel, Table, TableBody, TableHead, TableHeader, TableLoadingRow, TableRow, VFlow } from 'bold-ui'
import { TableBox } from 'components/table'
import { useHistoricoMarcadoresConsumoAlimentarQuery } from 'graphql/hooks.generated'
import { memo } from 'react'

interface HistoricoMarcadoresConsumoAlimentarPanelProps {
  uuidAtend: string
  cpfOuCnsCidadao: string
}

function HistoricoMarcadoresConsumoAlimentarPanel(props: HistoricoMarcadoresConsumoAlimentarPanelProps) {
  const { uuidAtend, cpfOuCnsCidadao } = props
  const {
    data: { historicoConsumoAlimentarDetail: historico },
    loading,
  } = useHistoricoMarcadoresConsumoAlimentarQuery({
    variables: {
      input: {
        cpfOuCnsCidadao,
        uuidAtend,
        isOrigemPec: false,
      },
    },
  })

  return (
    <VFlow>
      <VFlow vSpacing={0.5}>
        <Heading level={3}>{historico?.questionario}</Heading>
        {historico?.perguntasRespostas.map((perguntaResposta, index) => (
          <InfoLabel title={perguntaResposta.pergunta} key={index}>
            {perguntaResposta.respostas.join(', ')}
          </InfoLabel>
        ))}
      </VFlow>
      <TableBox>
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader>{historico?.subtitle}</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableLoadingRow colSpan={4} />
            ) : (
              <TableRow>
                <VFlow
                  vSpacing={0.5}
                  style={css`
                    padding: 1rem;
                  `}
                >
                  {historico?.perguntasRespostasOntem?.map((perguntaResposta, index) => (
                    <InfoLabel title={perguntaResposta.pergunta} key={index}>
                      {perguntaResposta.respostas.join(', ')}
                    </InfoLabel>
                  ))}
                </VFlow>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableBox>
    </VFlow>
  )
}

export default memo(HistoricoMarcadoresConsumoAlimentarPanel)
